import validator from 'validator';

export const required = (message = 'Required') => value => {
  if (!value.toString().trim().length) {
    // We can return string or jsx as the 'error' prop for the validated Component
    return message;
  }
};

export const email = (message = 'Invalid email format') => value => {
  if (!validator.isEmail(value)) {
    return message;
  }
};

export const phoneRegex = /^(\+?\d{0,4})?\s?-?\s?(\(?\d{3}\)?)\s?-?\s?(\(?\d{3}\)?)\s?-?\s?(\(?\d{4}\)?)?$/;

export const multiEmailsValidator = value => {
  if (!value) {
    return;
  }

  const emails = value.split(';');

  const areEmailsValid = emails.reduce((result, email) => {
    if (!result) {
      return result;
    }

    return !email || validator.isEmail(email);
  }, true);

  return !areEmailsValid;
};
